import React from 'react';

// Displays the list of players in the current room
function PlayerList({ players, copy = {}, language = 'he' }) {
  if (!players || players.length === 0) {
    return null;
  }

  const sorted = [...players].sort((a, b) => (b.score || 0) - (a.score || 0));
  const direction = language === 'he' ? 'rtl' : 'ltr';
  const alignStart = direction === 'rtl' ? 'right' : 'left';
  const title = copy.title || (language === 'he' ? 'שחקנים בחדר' : 'Players in the room');
  const playerHeader = copy.playerHeader || (language === 'he' ? 'שחקן' : 'Player');
  const scoreHeader = copy.scoreHeader || (language === 'he' ? 'ניקוד' : 'Score');
  const readyHeader = copy.readyHeader || (language === 'he' ? 'מוכן/ה' : 'Ready');
  const readyYes = copy.readyYes || (language === 'he' ? 'כן' : 'Yes');

  return (
    <div
      style={{
        margin: '0 auto 1rem',
        maxWidth: '400px',
        background: '#fff',
        borderRadius: '8px',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
        overflow: 'hidden',
      }}
      dir={direction}
    >
      <h3 style={{ textAlign: 'center', margin: '0.5rem 0' }}>{title}</h3>
      <table style={{ width: '100%', borderCollapse: 'collapse' }}>
        <thead>
          <tr style={{ backgroundColor: '#f0f0f0' }}>
            <th style={{ textAlign: alignStart, padding: '0.5rem' }}>{playerHeader}</th>
            <th style={{ padding: '0.5rem' }}>{scoreHeader}</th>
            <th style={{ padding: '0.5rem' }}>{readyHeader}</th>
          </tr>
        </thead>
        <tbody>
          {sorted.map(({ id, name, score, ready }, idx) => (
            <tr key={id}>
              <td style={{ padding: '0.5rem', textAlign: alignStart }}>
                {name} {idx === 0 && '👑'}
              </td>
              <td style={{ textAlign: 'center', padding: '0.5rem' }}>{score || 0}</td>
              <td style={{ textAlign: 'center', padding: '0.5rem' }}>{ready ? readyYes : ''}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default PlayerList;

